module.exports = __webpack_public_path__ + "static/media/noData.ee744e3e.svg";